import React from "react"
import WaypointCardContent from "@/features/route/WaypointCardContent.jsx"
import WaypointEditSection from "@/features/route/WaypointEditSection.jsx"

/**
 * Body of the waypoint info card: on manual-route waypoints the type of the
 * outgoing leg on top, then data rows and warnings. Delete is rendered in the
 * card header (WaypointDeleteAction) from the same `edit` object.
 */
export default function WaypointCardBody({
  feature,
  routeType,
  sketch = false,
  edit = null,
}) {
  return (
    <>
      {edit?.manual && edit?.onLegtypeChange ? (
        <WaypointEditSection
          nextLabel={edit.nextLabel}
          legtype={edit.legtype}
          onLegtypeChange={edit.onLegtypeChange}
          disabled={edit.disabled}
        />
      ) : null}
      <WaypointCardContent feature={feature} routeType={routeType} hideEmpty={sketch} />
    </>
  )
}
